import Cookies from "js-cookie";
const cookieKey = 'hideProductStrip';
const cookieDays = 365;

$(function() {
	$('.product-strip-close').on('click', function () {
		const expires = new Date(Date.now() + cookieDays * 24 * 3600 * 1000);
		Cookies.set(cookieKey, '1', {expires});
		$(this).closest('.messageStrip').slideUp();
	});
});
